import { useEffect, useState } from "react";
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from "recharts";
import { api } from "@/lib/api";

const COLORS = ["#DC1928", "#FF2D40", "#FF6B7A", "#FF9CA8", "#FFCBD3", "#A1A1AA"];

export default function AdminAnalytics() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/analytics").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="text-zinc-500">Lade…</div>;

  const issueData = data.top_issues.map((i) => ({ name: i._id, value: i.count }));
  const productData = data.top_products.map((p) => ({ name: p.name.slice(0, 20), qty: p.qty }));

  return (
    <div data-testid="admin-analytics">
      <div className="flex items-center justify-between mb-8">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">Insights</div>
          <h1 className="font-display text-3xl font-bold text-white mt-1">Analytics</h1>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-4 mb-4">
        <Card label="Umsatz Total" value={`€${data.revenue.total.toFixed(0)}`} sub={`${data.revenue.orders} Bestellungen`} />
        <Card label="Ø Warenkorb" value={`€${data.revenue.avg_order.toFixed(2)}`} sub="pro Bestellung" />
        <Card label="Reparaturen" value={data.repairs.total} sub="aller Zeiten" />
      </div>

      <div className="grid lg:grid-cols-2 gap-4">
        <div className="bg-[#141417] rounded-2xl border border-white/5 p-6">
          <h3 className="font-display font-semibold text-white mb-4">Umsatz-Verlauf</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data.daily_revenue}>
                <XAxis dataKey="date" stroke="#71717A" fontSize={11} />
                <YAxis stroke="#71717A" fontSize={11} />
                <Tooltip contentStyle={{ backgroundColor: "#141417", borderRadius: 12, border: "1px solid #27272A", color: "#fff" }} />
                <Line type="monotone" dataKey="revenue" stroke="#DC1928" strokeWidth={3} dot={{ fill: "#DC1928", r: 5 }} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-[#141417] rounded-2xl border border-white/5 p-6">
          <h3 className="font-display font-semibold text-white mb-4">Häufigste Probleme</h3>
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie data={issueData} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={80} label={{ fill: "#fff", fontSize: 11 }}>
                  {issueData.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip contentStyle={{ backgroundColor: "#141417", borderRadius: 12, border: "1px solid #27272A", color: "#fff" }} />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-[#141417] rounded-2xl border border-white/5 p-6 lg:col-span-2">
          <h3 className="font-display font-semibold text-white mb-4">Meistverkaufte Produkte</h3>
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={productData}>
                <XAxis dataKey="name" stroke="#71717A" fontSize={11} />
                <YAxis stroke="#71717A" fontSize={11} />
                <Tooltip contentStyle={{ backgroundColor: "#141417", borderRadius: 12, border: "1px solid #27272A", color: "#fff" }} />
                <Bar dataKey="qty" fill="#DC1928" radius={[8, 8, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

function Card({ label, value, sub }) {
  return (
    <div className="bg-[#141417] rounded-2xl border border-white/5 p-5">
      <div className="text-[10px] uppercase tracking-wider text-zinc-500">{label}</div>
      <div className="font-display text-3xl font-bold text-white mt-2 numeric">{value}</div>
      <div className="text-xs text-zinc-500 mt-1">{sub}</div>
    </div>
  );
}
